module.exports = __webpack_public_path__ + "static/sample-13-f2669072a6cb8199e1879468ccd228a7.png";